#import "../../../../../../core-entity/graphql/fragments/file-fragment.graphql"
fragment AccountAttachmentsFragment on Account {
    id
    files {
        ...FileFragment
    }
}
